import React from "react";
import { CheckCircle2, Pause, Archive, AlertCircle } from "lucide-react";

const STYLES = {
  active:   { bg: "bg-emerald-100", text: "text-emerald-700", border: "border-emerald-200", Icon: CheckCircle2 },
  inactive: { bg: "bg-slate-100",   text: "text-slate-600",   border: "border-slate-200",   Icon: Pause },
  archived: { bg: "bg-amber-100",   text: "text-amber-700",   border: "border-amber-200",   Icon: Archive },
  draft:    { bg: "bg-sky-100",     text: "text-sky-700",     border: "border-sky-200",     Icon: AlertCircle },
  pending:  { bg: "bg-amber-100",   text: "text-amber-700",   border: "border-amber-200",   Icon: AlertCircle },
};

const LABELS = {
  active:   "Active",
  inactive: "Inactive",
  archived: "Archived",
  draft:    "Draft",
  pending:  "Pending",
};

/**
 * StatusBadge — coloured pill for Active / Inactive / Archived / Draft.
 *
 *   <StatusBadge status="active" />
 *   <StatusBadge status={student.active ? "active" : "inactive"} />
 */
export default function StatusBadge({ status, label, size = "sm", testId }) {
  const key = (status || "").toString().toLowerCase();
  const s = STYLES[key] || STYLES.inactive;
  const Icon = s.Icon;
  const txt = label || LABELS[key] || (key ? key.charAt(0).toUpperCase() + key.slice(1) : "—");
  const sizeCls = size === "lg" ? "px-3 py-1 text-sm" : "px-2 py-0.5 text-xs";
  return (
    <span
      data-testid={testId || `status-badge-${key}`}
      className={`inline-flex items-center gap-1 ${sizeCls} rounded-full border ${s.bg} ${s.text} ${s.border} font-medium`}
    >
      <Icon className="h-3 w-3" />
      {txt}
    </span>
  );
}
